import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { defaultTo, path } from 'ramda';
import { connect } from 'react-redux';

import { routes } from '../../routes';

import Card from '../Card';

const mapStore = ({ memberships }) => ({ memberships });

const propTypes = {
  user: PropTypes.object,
  memberships: PropTypes.array,
};

const MembershipStatus = ({ user, memberships }) => {
  const latestRequest = defaultTo({}, user.latestMembershipRequest);
  const isActiveMember = path(['membership', 'valid'], user);
  const pendingReview = latestRequest.approved == null && latestRequest.year >= new Date().getFullYear();
  const hasRenewed = latestRequest.approved === true && latestRequest.year == window.env.REACT_MEMBERSHIP_YEAR;
  const emeritusMembership = defaultTo(
    {},
    memberships.find((option) => option.name.toLowerCase().indexOf('emeritus') !== -1),
  );

  if (pendingReview) {
    return (
      <Card membership className="mb-4">
        <Card.Header membership>Membership Status</Card.Header>
        <Card.Body>
          <p>
            Thank you for registering for {latestRequest.year} Membership. We are reviewing your{' '}
            {latestRequest.membershipId == emeritusMembership.categoryId ? 'request' : 'transcript'} and will confirm
            approval in 2-3 business days.
          </p>
        </Card.Body>
      </Card>
    );
  }

  if (isActiveMember) {
    const shouldRenew = window.env.REACT_MEMBERSHIP_YEAR > user.membership.year;

    return (
      <Card membership className="mb-4">
        <Card.Header membership>Membership Status</Card.Header>
        <Card.Body>
          <h3 className="dark-blue-heading">
            Your {hasRenewed ? latestRequest.year : user.membership.year} membership has been paid!
          </h3>
          <hr />
          {shouldRenew && !hasRenewed && (
            <Fragment>
              <p>Membership for {window.env.REACT_MEMBERSHIP_YEAR} is available now</p>
              <Link to={routes.membership.renew} className="btn btn-primary mr-3">
                Pay {window.env.REACT_MEMBERSHIP_YEAR} Membership
              </Link>
            </Fragment>
          )}
          <a href={routes.membership.resources} className="btn btn-outline-primary mr-2">
            Access Member Benefits
          </a>
        </Card.Body>
      </Card>
    );
  }

  // TODO: wording is a bit too hardcoded
  if (hasRenewed) {
    return (
      <Card membership className="mb-4">
        <Card.Header membership>Membership Status</Card.Header>
        <Card.Body>
          <h3 className="dark-blue-heading">Your {latestRequest.year} membership has been paid!</h3>
          <hr />
          <p>
            Thank you for registering for {latestRequest.year} Sage Financial Solutions Membership! Membership runs on a calendar year, but
            this year we are unlocking your member benefits early! Check back during the week of the{' '}
            {latestRequest.year - 1} Sage Financial Solutions Symposium to see all that your Member Dashboard has to offer!
          </p>
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card membership className="mb-4">
      <Card.Header membership>Membership Status</Card.Header>
      <Card.Body>
        <h3 className="dark-blue-heading">You are not currently a member, but we bet you would be a great one!</h3>
        <a href={routes.wordPress.membershipBenefits} target="_blank">
          Learn how Sage Financial Solutions Membership can benefit you!
        </a>
        {window.env.REACT_CLOSE_MEMBERSHIP_SIGNUP != true && (
          <Fragment>
            <hr />
            <p className="font-weight-bold">Become an Sage Financial Solutions Member</p>
            <Link to={routes.membership.renew} className="btn btn-primary">
              Sign up now
            </Link>
          </Fragment>
        )}
      </Card.Body>
    </Card>
  );
};

MembershipStatus.propTypes = propTypes;

export default connect(mapStore)(MembershipStatus);
